import { RefObject, useEffect, useState } from 'react'
import { pic } from 'assets/Icons'
import { IMAGES } from 'configs/configs.js'
import { hasAccess } from 'helper/utils'
import { Icon } from 'assets/index'
import trashWhite from './trashWhite.svg'
import {
  KanbanCard,
  Tag,
  CopyLink,
  Trashcan,
  AlertTags,
  YellowTag,
} from './style'

interface ICardProps {
  id?: string
  name: string
  tags: any
  specialistName?: string
  children?: any
  disabled?: boolean
  column?: string | number
  color: string
  background: string
  destinationList?: string[]
  cardData?: { [key: string]: string }
  onClick?(_param?: any): any
  ref?: (
    _instance: HTMLDivElement | null
  ) => void | RefObject<HTMLDivElement> | null
  isDragging?: boolean
  url?: any
  onTrash?: any
}
interface ILabel {
  content: string
  icon?: string
  id?: string
}

export function Label(props: ILabel) {
  const { content, icon, id } = props
  const profPic = icon ? `${IMAGES.URL}/images/${icon}` : pic

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div className="tooltip">
        <div className="kc-specialist">
          {id && id !== 'default' && (
            <img
              className="kc-picture"
              src={profPic}
              alt="profile"
              onError={(e) => {
                e.currentTarget.src = `${IMAGES.URL}/images/profile_placeholder.png`
                // caso a imagem não exista, exibe a imagem de perfil padrão
              }}
            />
          )}
          <span className="kc-span" data-tip data-for={`${id}-specialist`}>
            {id === 'default' ? 'Selecionar' : content}
          </span>
        </div>
        <span className="tooltiptext">{content}</span>
      </div>
    </div>
  )
}

export default function KanbanCardComponent(props: ICardProps) {
  const [copied, setCopied] = useState<boolean>(false)
  const { name, tags, children, url, id, onTrash } = props
  const [updatedTags, setUpdatedTags] = useState<any>(tags)

  const handleCopy = () => {
    navigator.clipboard.writeText(url)
    setCopied(true)

    setTimeout(() => {
      setCopied(false)
    }, 3000)
  }

  const hasAnalysisTag = tags?.some(
    (tag: { value: string }) => tag.value === 'Analisar'
  )

  const hasManualPaymentTag = tags?.some(
    (tag: { value: string }) => tag.value === 'Pagamento Manual'
  )

  useEffect(() => {
    if (hasAnalysisTag || hasManualPaymentTag) {
      // Remove a tag com value igual a "Analisar"
      const filteredTags = tags?.filter(
        (tag: { value: string }) =>
          tag.value !== 'Analisar' && tag.value !== 'Pagamento Manual'
      )
      setUpdatedTags(filteredTags)
      // Atualize o estado de tags sem a tag "Analisar"
    }
  }, [])
  // Atualize o estado de tags sem a tag "Analisar" e cria um boleano para rederizar em outro lugar

  return (
    <div
      style={{ position: 'absolute', width: '100%' }}
      data-testid={`card-${name}`}
    >
      {hasAccess('trash-remove-proposta') && onTrash && (
        <Trashcan
          id="trash-remove-proposta"
          data-tip
          data-for={`trashcan`}
          style={{ zIndex: 999 }}
          src={trashWhite}
          onClick={() => onTrash(id)}
        />
      )}

      <KanbanCard {...props}>
        <div>
          {(hasAnalysisTag || hasManualPaymentTag) && (
            <AlertTags className="alert">
              {hasManualPaymentTag && <YellowTag>Manual</YellowTag>}
              {hasAnalysisTag && <YellowTag>Analisar</YellowTag>}
            </AlertTags>
          )}
          <div className="trash-row tooltip2">
            <span
              className="kc-name"
              data-tip
              data-for={`${id}-name`}
            >{`${name?.substring(0, 16)}${
              String(name).length > 16 ? '...' : ''
            }`}</span>
            <span className="tooltiptext2">{name}</span>
          </div>
          <div className="kc-tags-container">
            {updatedTags?.map((tag: any, i: number) => {
              return (
                <div className="tooltip" key={`${tag.value}+${i}-${id}`}>
                  <Tag
                    data-tip
                    data-for={`${id}-${i}`}
                    background={tag.background}
                    color={tag.color}
                    className="tag"
                  >
                    {tag.value}
                  </Tag>
                  {tag.tooltip && (
                    <span className="tooltiptext">{tag.tooltip}</span>
                  )}
                </div>
              )
            })}
          </div>
        </div>

        {children}
      </KanbanCard>
      {url && (
        <CopyLink onClick={() => handleCopy()}>
          {copied ? (
            <>
              <img
                className="link-copy-icon"
                src={Icon('check_circle.svg')}
                alt="link"
              />
              <p className="link-copy-text">Link copiado</p>
            </>
          ) : (
            <>
              <img
                className="link-copy-icon"
                src={Icon('link.svg')}
                alt="link"
              />
              <p className="link-copy-text">Copiar link de cadastro</p>
            </>
          )}
        </CopyLink>
      )}
    </div>
  )
}
